import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../components_web/Header";
import Footer from "../components_web/Footer";
import SideMenu from "../components_web/SideMenu";
import { getClass } from "../src/helpers/formatHelpers";

const WebsitePro = () => {
  const { t } = useTranslation();
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);

  return (
    <div>
      <NextSeo
        title={`${process.env.NEXT_PUBLIC_APP_NAME} Pro`}
        description={
          "Add your cocktail bar on the #1 guide for cocktail bars in the world. For the cocktail bars already listed, upgrade now the profile status of your cocktail bar to increase its visibility on our platform."
        }
        canonical={`https://${
          process.env.NEXT_PUBLIC_WWW_BASE_URL
        }/${process.env.NEXT_PUBLIC_APP_NAME?.replace(
          " ",
          ""
        )?.toLowerCase()}-pro`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${
            process.env.NEXT_PUBLIC_WWW_BASE_URL
          }/${process.env.NEXT_PUBLIC_APP_NAME?.replace(
            " ",
            ""
          )?.toLowerCase()}-pro`,
          title: `${process.env.NEXT_PUBLIC_APP_NAME} Pro`,
          description:
            "Add your cocktail bar on the #1 guide for cocktail bars in the world. For the cocktail bars already listed, upgrade now the profile status of your cocktail bar to increase its visibility on our platform.",
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className={`${getClass("background", true)} py-40`}>
        <div className="wrapper mx-auto relative md:py-7% sm:py-20 py-10">
          <div className="max-w-1160px flex-1 mx-auto">
            <div className="flex flex-col items-center">
              <h1
                className={`sm:text-3xl text-lg font-bold ${getClass(
                  "text-white",
                  true
                )} text-center sm:mb-14 mb-6 uppercase`}>
                {process.env.NEXT_PUBLIC_APP_NAME} Pro
              </h1>
              <div className="flex flex-col justify-center items-center">
                <p
                  className={`sm:text-lg text-sm font-regular text-center ${getClass(
                    "text-white80",
                    true
                  )}`}>
                  Add your cocktail bar on the #1 guide for cocktail bars in the
                  world.
                </p>
                <p
                  className={`sm:text-lg text-sm font-regular text-center ${getClass(
                    "text-white80",
                    true
                  )} sm:mt-0 mt-2 mb-8`}>
                  For the cocktail bars already listed, upgrade now the profile
                  status of your cocktail bar to increase its visibility on our
                  platform.
                </p>
                <div
                  className={`sm:text-[26px] text-sm font-bold text-center ${getClass(
                    "text-pink",
                    true
                  )} mb-8`}>
                  JOIN US NOW
                </div>
                <a
                  href={'/contact'}
                  className={`${getClass(
                    "btn-gradient"
                  )} p-4 rounded-full text-xl text-white hover:underline font-semibold uppercase text-center w-full max-w-[330px]`}
                  target="_blank"
                  rel="noreferrer">
                  APPLY
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default WebsitePro;
